import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import AttributeCardContainer from "ui/organisms/AttributeCardContainer";
import { AiOutlineQuestion } from "react-icons/ai";
import Modal from "ui/atoms/Modal";
import useGenerator from "hooks/useGenerator";

function Generator() {
  const {
    isPreviewLoading,
    isModalOpen,
    setIsModalOpen,
    uploadedAttributes,
    isCreated,
    showProgress,
    generatePreview,
    getZip,
    uploadLabel,
    getInputProps,
    getRootProps,
    setUploadedAttributes,
  } = useGenerator();

  return (
    <>
      <div className="relative bg-[#1A132F] w-screen min-h-screen flex flex-col md:flex-row flex-1 pt-16 items-center justify-center">
        {showProgress && (
          <div className="absolute z-[999] top-16 h-16 left-0 right-0 bg-white">
            <div className="flex items-center justify-center w-full h-full">
              <p className="text-black font-medium text-2xl">{uploadLabel}</p>
            </div>
          </div>
        )}
        <button
          onClick={() => setIsModalOpen(!isModalOpen)}
          className="absolute top-[84px] right-[20px] rounded-full border-2 border-white p-1"
        >
          <AiOutlineQuestion color="#FFF" size="24px" />
        </button>
        <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        <div className="h-[520px] mx-3 my-5 md:m-0 overflow-scroll rounded-lg border-4 border-pink-400">
          <div
            className="flex w-full md:w-[820px] bg-rose-200 py-5 items-center justify-center"
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
              <DndProvider backend={HTML5Backend}>
                <AttributeCardContainer
                  attributes={uploadedAttributes}
                  onOpenModal={() => console.log("open modal later")}
                  setAttributes={setUploadedAttributes}
                />
              </DndProvider>
            </div>
            <div
              className={`${
                uploadedAttributes.length > 0 && "hidden"
              } flex h-[472px] flex-1 justify-center items-center`}
            >
              <span className="font-exo text-2xl text-center">
                Drag and drop your image folder here...
              </span>
            </div>
          </div>
        </div>
        <div className="text-white font-bold flex flex-col md:ml-20 md:mb-0 mb-8">
          <button
            disabled={isPreviewLoading || uploadedAttributes.length === 0}
            onClick={() => generatePreview()}
            className={`${
              isPreviewLoading || uploadedAttributes.length === 0
                ? "bg-gray-400"
                : "hover:scale-110 bg-gradient-to-br from-pink-400 to-[#61A4BC]"
            } transition-transform duration-300 ease-in-out mb-5 md:mb-10 p-1 rounded-2xl w-[192px] h-[50px] `}
          >
            <span className="text-lg font-exo text-slate-100 font-bold tracking-wide">
              Preview Image
            </span>
          </button>
          <button
            disabled={isPreviewLoading || !isCreated}
            onClick={() => getZip()}
            className={`${
              isPreviewLoading || !isCreated
                ? "bg-gray-400"
                : "hover:scale-110 bg-gradient-to-br from-pink-400 to-[#61A4BC]"
            } transition-transform duration-300 ease-in-out p-1 rounded-2xl w-[192px] h-[50px] `}
          >
            <span className="text-lg font-exo text-slate-100 font-bold tracking-wide">
              Download Zip
            </span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Generator;
